// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__RtGUQ","container":"styles_container__ezaqG","title":"styles_title__2VARW","wrapper":"styles_wrapper__E3LZp","answer":"styles_answer__2SXPU"};